import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/south-padre-island")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in South Padre Island, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for South Padre Island & Cameron County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — South Padre Island, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving South Padre Island and Cameron County.",
      keywords: "awnings South Padre Island, awning company South Padre Island, custom awnings South Padre Island, sail shades South Padre Island, patio covers South Padre Island, pergola covers South Padre Island, metal awnings South Padre Island, canvas awnings South Padre Island, Texas Made Shade",
    }),
    scripts: cityHeadScripts("South Padre Island", "Cameron County"),
  }),
  component: () => <CityHomePage city="South Padre Island" region="Cameron County" />,
});
